import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import messages from './messages';
import Avatar from '../../components/Avatar';
import Grid from '../../components/Grid';
import Contact from './event-contact';
import { getAddress } from '../ContactsContainer/util';
import Header from '../../components/Header';
import './styles.css';

const EventDetails = ({ type, highSchool, eventDetails }) => {
  const { contact, phone, instructions, cost, expectedStudents } = eventDetails;
  const highSchoolName = get(highSchool, 'name');
  const highSchoolAddress = getAddress(get(highSchool, 'address'));
  return (
    <Grid>
      <Grid.Row styleName="row-details">
        <Grid.Column>
          <Header.Subheader as="h5" styleName="sub-title">
            {type === 'fair'? <FormattedMessage {...messages.location} /> : <FormattedMessage {...messages.school} />}
          </Header.Subheader>
          <div>
            <Avatar small icon="university" />
            <div styleName="school-name">
              {highSchoolName}
            </div>
            <div styleName="address">
              {highSchoolAddress}
            </div>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row styleName="row-details">
        <Grid.Column>
          <Header.Subheader as="h5" styleName="sub-title">
            <FormattedMessage {...messages.contact} />
          </Header.Subheader>
          <Contact contact={contact} phone={phone} />
        </Grid.Column>
      </Grid.Row>
      {type === 'fair' && (
      <Grid.Row styleName="row-details">
        <Grid.Column width={8} styleName="sub-title" size="small">
          <FormattedMessage {...messages.cost} />
          <div styleName="sidebar-text">
            {cost}
          </div>
        </Grid.Column>
        <Grid.Column width={8} styleName="sub-title" size="small">
          <FormattedMessage {...messages.expectedstudents} />
          <div styleName="sidebar-text">
            {expectedStudents}
          </div>
        </Grid.Column>
      </Grid.Row>
      )}
      <Grid.Row styleName="row-details">
        <Grid.Column styleName="sub-title">
          <Header.Subheader as="h5" styleName="sub-title">
            <FormattedMessage {...messages.instructions} />
          </Header.Subheader>
          <div styleName="sidebar-text">
            {instructions}
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

EventDetails.propTypes = {
  type: PropTypes.string.isRequired,
  highSchool: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
};

export default EventDetails;
